module.exports = __webpack_public_path__ + "static/img/project/cydc2025logo.png";